/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { Channel } from '../../core/entities';
import { TChannelV2, TOverlayOptions, TProgramCell } from '../../core/types';
import { OverlayTypes } from '../overlay/OverlayTypes';

export const DescriptionType = {
    DEFAULT: 'DEFAULT',
    PROGRAM_DESCRIPTION: 'PROGRAM_DESCRIPTION',
    FADED_DESCRIPTION: 'FADED_DESCRIPTION',
};

export interface IDescriptionEntry {
    text: string;
    hrBottom?: boolean;
    hrTop?: boolean;
    descriptionType?: (typeof DescriptionType)[keyof typeof DescriptionType];
}

export interface IOverlayDialog {
    hasDimmer: boolean;
    hasSeperator: boolean;
    options: Array<TOverlayOptions>;
    title: string;
    channel?: Channel | TChannelV2;
    description?: string | Array<IDescriptionEntry>;
    dimmerOpacity?: number;
    enableCaret?: boolean;
    errorPriority?: number;
    iconURL?: string;
    isLargeSizeOverlay?: boolean;
    isPersistent?: boolean;
    messageCode?: string;
    mouseTrapValue?: string;
    onAutoHide?: Function;
    overlayType?: OverlayTypes;
    programCell?: TProgramCell;
    subtitle?: string | { text: string; icon: string };
    verticalPositionCaretAvailable?: Array<number>;
    maxInputLength?: number;
    initialVerticalIndex?: number;
}
